<div *ngIf="processedTags" class="container">
    <div class="tag" *ngFor="let tag of processedTags" (click)='onTagClicked(tag)'
        [ngStyle]="tag.active?tag.styleActive:tag.styleNoActive">
        {{tag.label | translate}}
    </div>
</div>